export default "/_next/static/images/2eb4763daf7f6b3369a9b238a63c6c60.jpg";